import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { AREAS } from "@/lib/site";
import { Reveal } from "@/components/Reveal";

export const AreasStrip = ({ serviceName }) => {
  const lower = serviceName.toLowerCase();
  return (
    <section data-testid="areas-strip" aria-labelledby="areas-strip-heading" className="section section-alt">
      <div className="container-site">
        <Reveal className="max-w-[720px]">
          <h2 id="areas-strip-heading">{serviceName} Across Surrey &amp; South West London</h2>
          <p className="sub-line mt-4 text-body">
            We are based in Molesey and carry out {lower} throughout the surrounding towns. Choose your area for local details.
          </p>
        </Reveal>
        <ul className="mt-10 grid gap-x-8 gap-y-1 sm:grid-cols-2 lg:grid-cols-4">
          {AREAS.map((a, i) => (
            <Reveal as="li" key={a.id} delay={i * 60}>
              <Link
                to={a.to}
                data-testid={`areas-strip-link-${a.id}`}
                className="group flex items-center justify-between gap-3 border-b border-line py-3 text-base font-medium text-navy transition-colors duration-200 hover:text-brand"
              >
                {serviceName} in {a.name}
                <ArrowRight size={18} aria-hidden="true" className="shrink-0 text-brand transition-transform duration-200 ease-out group-hover:translate-x-1" />
              </Link>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
};
